var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isFetchingWidgets)?_c('div',{staticClass:"widgets-container"},_vm._l((_vm.widgets),function(widget){return _c('widget',{key:widget.title,attrs:{"widget":widget}})}),1):_c('div',{staticClass:"widgets-container"},_vm._l((6),function(n){return _c('v-skeleton-loader',{key:n,attrs:{"type":"card","width":"141","height":"100"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }